import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import WhatsAppButton from './components/feature/WhatsAppButton';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="min-h-screen flex flex-col">
        <AppRoutes />
        <WhatsAppButton />
      </div>
    </BrowserRouter>
  );
}

export default App;